import { Flex } from 'lib/components/styles/layout';
import React from 'react';
import styled from 'styled-components/macro';
import {
  CheckboxSkeleton,
  LabelSkeleton,
  Shimmer,
  ShimmerWrapper,
} from './styles';

const Container = styled.div`
  height: 295px;
  width: 100%;

  display: flex;
  justify-content: space-between;

  background: transparent;
  position: relative;
  overflow: hidden;
  padding: 0;
`;

const SkeletonLoader = () => {
  const dummyData = Array.from(Array(7).keys());
  return (
    <Container>
      <Flex gap={'25px'}>
        {dummyData.map(d => (
          <LabelSkeleton key={`row1-label-${d}`} />
        ))}
      </Flex>
      <Flex gap={'25px'} alignItems='center'>
        {dummyData.map((d, index) => {
          if (!index) return <LabelSkeleton key={`row2-label-${d}`} />;
          return <CheckboxSkeleton key={`row2-checkbox-${d}`} />;
        })}
      </Flex>
      <Flex gap={'25px'} alignItems='center'>
        {dummyData.map((d, index) => {
          if (!index) return <LabelSkeleton key={`row3-label-${d}`} />;
          return <CheckboxSkeleton key={`row3-checkbox-${d}`} />;
        })}
      </Flex>

      <ShimmerWrapper>
        <Shimmer />
      </ShimmerWrapper>
    </Container>
  );
};

export default SkeletonLoader;
